import * as React from 'react';

const ScanCheckSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="scan-check_svg__eds-icon--scan-check_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="scan-check_svg__eds-icon--scan-check_check"
            d="M15.3 9.5L11 13.8l-2.3-2.3-.7.7 3 2.8 5-4.8z"
        />
        <g id="scan-check_svg__eds-icon--scan-check_corners">
            <path d="M2 8h1V3h5V2H2zM16 2v1h5v5h1V2zM21 21h-5v1h6v-6h-1zM3 16H2v6h6v-1H3z" />
        </g>
    </svg>
);

ScanCheckSvg.displayName = 'ScanCheckSvg';
export default ScanCheckSvg;
